import React from 'react';

import './index.css';

import { Button, Checkbox, Container, Divider, Dropdown, Form, Grid,
    Input, Loader, Menu, Message, Modal, Popup, Radio, Table, TextArea } from 'semantic-ui-react'

import {
    encryptData,
    saveEncryptedP2PKHKey,

    decryptData,                   // for new-fangled wallet import

    saveEncryptedWallet,
    saveEncryptedKeys,
    getEncryptedKeysFromPKH,
    getEncryptedKeysFromAddress,  //officialP2pkhTab  FIXME: generalize these two
    getEncryptedKeyFromAddress,   //p2pkhTab

    registerDomainOfMine,
    registerBuiltDomain,

    saveSetting,
    readSetting,
    deleteSetting,

    openDB,
} from '../node_modules/shizzle-core/dist/es/shizzle-core.js'

import { bshzColors } from './bshzColors';

// https://www.npmjs.com/package/react-semantic-ui-datepickers
// https://github.com/arthurdenner/react-semantic-ui-datepickers
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';



import { bsv } from 'scryptlib';

const ebx_deposits_idb_label = "__ebx_deposits"

//NOTE: there is no .blocktime in ebx deposit records
//      Currently there is a .date, and .time
function compareByBlockTime( a, b ) {
    if ( a.blocktime < b.blocktime ){
      return -1;
    }
    if ( a.blocktime > b.blocktime ){
      return 1;
    }
    return 0;
  
  }

class EbxDepositsImporter extends React.Component {
  constructor(props) {
    super(props);

    this.showImporter               = this.showImporter.bind(this);
    this.disappearImporter          = this.disappearImporter.bind(this);
    this.showAnalysis               = this.showAnalysis.bind(this);
    this.hideAnalysis               = this.hideAnalysis.bind(this);
    this.showClearData              = this.showClearData.bind(this);
    this.hideClearData              = this.hideClearData.bind(this);
    this.actuallyDeleteData         = this.actuallyDeleteData.bind(this);

    this.analyzeDeposits            = this.analyzeDeposits.bind(this);
    this.reviewDeposits             = this.reviewDeposits.bind(this);
    this.exportCoinsToCsvFile       = this.exportCoinsToCsvFile.bind(this);

    this.getPersistedDeposits       = this.getPersistedDeposits.bind(this);

    this.editStartDate              = this.editStartDate.bind(this);
    this.editEndDate                = this.editEndDate.bind(this);
    this.toggleStartDateLimit       = this.toggleStartDateLimit.bind(this);
    this.toggleEndDateLimit         = this.toggleEndDateLimit.bind(this);
    this.toggleShowStartDateModal   = this.toggleShowStartDateModal.bind(this);
    this.toggleShowEndDateModal     = this.toggleShowEndDateModal.bind(this);
    this.onStartDateChange          = this.onStartDateChange.bind(this);
    this.onEndDateChange            = this.onEndDateChange.bind(this);
    this.editStartDate              = this.editStartDate.bind(this);
    this.editEndDate                = this.editEndDate.bind(this);


    this.solicitPassword = this.solicitPassword.bind(this);
    //this.inspectContents = this.inspectContents.bind(this);

    this.importFundingKey= this.importFundingKey.bind(this);
    this.importPayoutKeys= this.importPayoutKeys.bind(this);
    this.importRabinKeys = this.importRabinKeys.bind(this);

    this.importDomainsClaimed = this.importDomainsClaimed.bind(this);
    this.importDomainsBuilt   = this.importDomainsBuilt.bind(this);


    this.allowPaste      = this.allowPaste.bind(this);
    this.handlePaste     = this.handlePaste.bind(this);

    this.handleBsvKey    = this.handleBsvKey.bind(this);
    this.handlePwdChange = this.handlePwdChange.bind(this);

    // for new-fangled wallet import, we need to decrypt with a password
    this.useEnteredPasswordToDecrypt = this.useEnteredPasswordToDecrypt.bind(this);

    this.walletReaderFunc  = this.walletReaderFunc.bind(this);

    //FIXME: the purples are currently duplicated in index.css
    this.bshzPurple             = '#8313e2';
    this.bshzYellow             = "#fff300";
    this.bshzLtPurp             = '#e7d0fb';
    this.bshzLightYellow        = "#fffccc";

    this.state = {
                    showImporterModal: false,
                    showAnalysisModal: false,
                    showClearDataModal: false,

                    showEndDateSetter: false,
                    limitEndDate: false,
                    endDateLimit: null,
                    disableSetEndDateButton: true,
                    rawEndDateValue: '',
              
                    showStartDateSetter: false,
                    limitStartDate: false,
                    startDateLimit: null,
                    disableSetStartDateButton: true,
                    rawStartDateValue: '',

                    disableButtons: false,

                  enableInspectButton: false,
                  numItemsToImport: ' ',
                  invalidImportFile: false,

                  enablePaste: false,
                  enableInspectButton2: false,
                  numItemsToImport2: ' ',
                  invalidImportFile2: false,

                  importClicked: false,

                  showOkModal: false,
                  keysSkipped: 0,

                  totalRecordsCount: 0, // count of ALL records that were imported (not skipped)

                  getPwdForPriv: false,  //NOTE: might not be used. Maybe vestige from rabin-handling code
                  priv:          null,

                  pwd:           '',
                  showPasswordInputField: false,

                  walletGibberish: '',
                  walletVersion: '',
                  walletNetwork: '',
                  walletBlob: '',

                  disablePasteButton: false,

                  showImportSwirly: false
                };
  }

  allowPaste() {
    console.log("Allow paste")

    //FIXME: consider disabling other option (imorting file)

    this.setState({enablePaste: true, disablePasteButton: true})
  }
  handlePaste(event, data) {
    if ( data.value.length > 300000 ) {
      alert("ERROR: Your backup file is too long. If you believe your backup is valid, please report this problem.")
      return
    }

    const value = data.value.substr(0, 300000)
    console.log("Change to backup text box...")
    //console.log("text: ", value)

    //NOTE: adapted from componentDidMount() option, below

    const jsonString = value;
    console.log("placed (paste) content of length " + jsonString.length);

    try {
      const contents = JSON.parse(jsonString)

      console.warn("These are the RAW contents: ", jsonString)
      console.warn("These are the JSON-parsed contents: ", contents)

      this.setState({enableInspectButton2: true, numItemsToImport2: (' ' + contents.length)});
      this.setState({invalidImportFile2: false, pastedContents: jsonString});
    } catch (error) {
      console.log("invalid wallet text/gibberish: ", error);
      this.setState({invalidImportFile2: true});
    }

  }

  showImporter() {
    this.setState({showImporterModal: true, enableInspectButton: false, numItemsToImport: ' ', invalidImportFile: false},
            () => {
                //alert("ADDING listener...")
                document.getElementById('inputFileHolder').addEventListener('change', this.walletReaderFunc);
            }
        );

  }
  disappearImporter() {
    //alert("REMOVING listener...")
    document.getElementById('inputFileHolder')?.removeEventListener('change', this.walletReaderFunc)

    this.setState({showImporterModal: false})
  }

  async getPersistedDeposits() {
    const persistedEbxDepositsJson = await readSetting(await openDB(), ebx_deposits_idb_label)

    console.log("===>  persistedEbxDepositsJSON: ", persistedEbxDepositsJson)

    if ( persistedEbxDepositsJson === null ) {
      return []
    }

    const ebxDeposits = JSON.parse( persistedEbxDepositsJson.value )
    console.warn("json-parsed ebx deposit entries: ", ebxDeposits)

    return ebxDeposits
  }

  async exportCoinsToCsvFile(textFile) {
    console.log("handleExport()")

    const options = {
        types: [
            {
            description: 'Text Files',
            accept: {
                'text/plain': ['.txt'],
            },
            },
        ],
    };

    let success = false
    try {
        const fileHandle = await window.showSaveFilePicker(options);

        // FileSystemWritableFileStream.
        const writable = await fileHandle.createWritable();

        //console.log("Will write these records: " + records)

        // Write to the stream.
        //await writable.write(records);    // whoops. that was only the FUNDING
        await writable.write(textFile);

        // Close and write to disk.
        await writable.close();

        console.error("We think the file was successfully saved")
        success = true
        //this.props.closeWalletExportModal();
    } catch (error) {
        console.error("Wallet Export Error: " + error + "\n");
        //alert('We had trouble trying to write the Wallet Key file. Perhaps your browser doesn\'t support this: ' + error);

        console.warn("Your browser doesn't support writing to a file. We COULD build a file for DISPLAY - which you could then copy/paste.")

        alert("We encountered an error trying to save your CSV file. Perhaps your browser doesn't support this operation?\n\nPlease check the java console for an error message.")
    }

    if ( success ) {
      //alert("We think the file was successfully saved!")
    }
  }

  async reviewDeposits(ebxDeposits, startDate = null, endDate = null,
                        exportToCSV = false, lumpByDate = false, includeMarketValue = false) {

    console.log('reviewDeposits() start: ', startDate)
    console.log('reviewDeposits() end: ', endDate)
    console.log('reviewDeposits() exportToCSV: ', exportToCSV)
    console.log('reviewDeposits() lumpByDate: ', lumpByDate)
    console.log('reviewDeposits() includeMarketValue: ', includeMarketValue)

    if ( exportToCSV && !lumpByDate ) {
        alert("Whoops. We're sorry. We haven't yet implemented non-lumped exporting-to-file")
        return
    }

    console.log('reviewDeposits() utxos: ', ebxDeposits)
    console.warn("restrict by start date " + startDate)
    console.warn("restrict by end date " + endDate)
    if ( ebxDeposits.length === 0 ) {
      console.log("was empty, so, lets get utxos")
      ebxDeposits = await this.getPersistedDeposits() // payoutsSettingLabelPrefix + this.state.minerAddress)     //.txId, .blockHeight
    }

    // not currently suited for compareByBlockTime
    //ebxDeposits.sort(compareByBlockTime)

    console.warn("There are " + ebxDeposits.length + " cached deposits (which should ALREADY be sorted)")


    const entriesToExport = ["Date,Type,Sent Asset,Sent Amount,Received Asset,Received Amount,Fee Asset,Fee Amount,Market Value Currency,Market Value,Description,Transaction Hash,Transaction ID"]

    let adamsDateMap = new Map()

    // use two maps to check for any duplications
    const coinDateTimeMap = new Map()
    const adamsMap = new Map()

//    let blocksCountDateMap = new Map()
//    let txidMap = new Map()
    let i = 0
    let totalAdams = 0
    let maxBlockHeight = 0
    let paymentsOfInterestCount = 0
    let paymentsSkipped = 0
    let datesOfInterest_finalTxTime = new Map()
    for ( const coin of ebxDeposits ){
      ++i

      // FILTER-OUT dates AFTER the endDate (if not null)
      const dateSnippet = coin.date.substr(0, 10)
      console.log("date substring: ", dateSnippet)
      const timeSnippet = coin.time.substr(0, 8)

      const datePlusTimeString = dateSnippet + timeSnippet

      // CHECK if there's any duplication...
      //const entryForDatePlusTimeSoFar = coinDateTimeMap.get(datePlusTimeString)
      //if ( typeof entryForDatePlusTimeSoFar !== 'undefined' ) {
      //  console.error("DATESTAMP. iteration " + i + ": We may have a double entry for datePlusTime of " + datePlusTimeString + " :  value " + entryForDatePlusTimeSoFar)
      //} else {
        coinDateTimeMap.set(datePlusTimeString, coin.adams)
      //}

      //const entryForAdams = adamsMap.get(coin.adams)
      //if ( typeof entryForAdams !== 'undefined' ) {
      //  console.error("ADAMS. iteration " + i + ": We may have a double entry for adams amount of " + coin.adams + " :  value " + entryForAdams +
      //        "\n\nTHIS iteration we have a date+time stamp of " + datePlusTimeString
      //  )
       //alert("That's not necessarily wrong")
      //} else {
        adamsMap.set(coin.adams, datePlusTimeString)
      //}


      // comparing strings: https://stackoverflow.com/questions/10198257/comparing-2-strings-alphabetically-for-sorting-purposes
      if ( startDate !== null && startDate.localeCompare( dateSnippet ) > 0 ) {
        // SKIP this date (1 means startDate is after dateSnippet)
    //    console.warn("Compared startDate " + startDate + " to dateSnippet " + dateSnippet + ": ", startDate.localeCompare( dateSnippet ) + " - SKIPPING" )
        paymentsSkipped++
        continue
      } else if ( endDate !== null && endDate.localeCompare( dateSnippet ) < 1 ) {
        // SKIP this date (0 or -1 means endDate is equal to, or before dateSnippet)
    //    console.warn("Compared endDate " + endDate + " to dateSnippet " + dateSnippet + ": ", endDate.localeCompare( dateSnippet ) + " - SKIPPING")
        paymentsSkipped++
        continue
      } else {
        console.warn("Proceeding with dateSnippet " + dateSnippet + " (time " + timeSnippet + ") <========")
        datesOfInterest_finalTxTime.set(dateSnippet, timeSnippet)
      }

      ++paymentsOfInterestCount

      {


        // EVENTUALLY: Enter logic for UN-LUMPED CSV file


      }

      const adamsInThisCoin = parseInt( coin.adams.replace(/,/g, '') )
      console.log("coin.adams: ", coin.adams)

      //const adamsInThisCoin = (parseFloat( coin.amt) * 1000) * 100000000
      //console.log("(coin.amt: ", coin.amt + ")")

      //console.log("parseInt(): ", parseInt(coin.adams))
      //console.log("  replaced: ", coin.adams.replace(/,/g, ''))
      console.log(" ....adamsInThisCoin: ", adamsInThisCoin)


      totalAdams += adamsInThisCoin



      //if ( coin.blockHeight > maxBlockHeight ) {
      //  maxBlockHeight = coin.blockHeight
      //}

      console.warn("coin " + i + " of " + ebxDeposits.length)
      //console.log("  .txId: ", coin.txId)
      //console.log("  .blockHeight: ", coin.blockHeight)
      //console.log("  .outputIndex: ", coin.outputIndex)
      console.log("  .adams: ", coin.adams)
      console.log("  .time: ", coin.time)
      console.log("  .date: ", coin.date)
      console.log(" running total of adams: " + totalAdams)

      /*
      if ( txidMap.get(coin.txId) ) {
        console.error("reviewCachedPayments(): WHOOPS: found a duplicate, persisted utxo - for txId ", coin.txId)
        alert("Duplicate persisted utxo found: " + coin.txId)
        alert("FIXME: remove the duplicate persisted utxo")
      } else {
        txidMap.set(coin.txId, true)
      }
      */

      const adamsOnDateSoFar = adamsDateMap.get(dateSnippet)
      console.log("adams on date so far: ", adamsOnDateSoFar)
      if ( typeof adamsOnDateSoFar === 'undefined' ) {
        adamsDateMap.set(dateSnippet, adamsInThisCoin)
        console.warn("adams: First time for " + dateSnippet + ": " + adamsInThisCoin + " adams  <----<<")
      } else {
        adamsDateMap.set(dateSnippet, adamsOnDateSoFar + adamsInThisCoin)
        console.warn("adams: Update for " + dateSnippet + ": " + (adamsOnDateSoFar + adamsInThisCoin) + " adams  <--")
      }

      /*
      const blocksOnDateSoFar = blocksCountDateMap.get(dateSnippet)
      console.log("blocks on date so far: ", blocksOnDateSoFar)
      if ( typeof blocksOnDateSoFar === 'undefined' ) {
        blocksCountDateMap.set(dateSnippet, 1)
        console.warn("blocks: First time for " + dateSnippet + ": 1 block              <----<<")
      } else {
        blocksCountDateMap.set(dateSnippet, blocksOnDateSoFar + 1)
        console.warn("blocks: Update for " + dateSnippet + ": " + (blocksOnDateSoFar + 1) + "sats  <--")
      }
      */
      console.log("------------------")
    } // loop over payments

    console.warn("There are " + adamsDateMap.size + " date entries")
    console.warn("We skipped " + paymentsSkipped + " deposits (outside of specified date range)")
    console.warn("Here they are: ", adamsDateMap)

    const marketValueCurrency = includeMarketValue ? "USD" : ""
    let alternativeRunningCount = 0.0
    const ebxPriceOnThisDate = 0.25 // USD
    let totalDollars = 0.0

    console.error("datesOfInterest_finalTxTime: ", datesOfInterest_finalTxTime)

    for(const key of adamsDateMap.keys()) {
        const theDate = key
        const adamsTotalForDay = adamsDateMap.get(theDate)
                                //Math.round((adamsDateMap.get(theDate) + Number.EPSILON) * 100000000000) / 100000000000
        const ebxTotalForDay = adamsTotalForDay / 100000000000

        const dollarsToday = ebxPriceOnThisDate * ebxTotalForDay
        totalDollars += dollarsToday

        console.log("  adams for key/date " + theDate + ":", ebxTotalForDay + " EBX -  $" + dollarsToday)//(adamsDateMap.get(key)/ 100000000000))
        alternativeRunningCount += (adamsTotalForDay / 100000000000)

          // build-up a CSV file - with entries for each DAY (lump multiple txs per day)
          if ( exportToCSV && lumpByDate && datesOfInterest_finalTxTime.has( theDate ) ) {
            console.error("Date " + theDate + " belongs in this CSV file")
            //console.warn("ADDING a row for date " + theDate)

            const timeSnippet = datesOfInterest_finalTxTime.get( theDate )

            //Date,Type,Sent Asset,Sent Amount,Received Asset,Received Amount,Fee Asset,Fee Amount,Market Value Currency,Market Value,Description,Transaction Hash,Transaction ID
            // {Date},Mining, , ,BSV,{amount in BSV},,,,,,,
            entriesToExport.push("" + theDate
                                    + " " + timeSnippet       //WARNING: lumping multiple txs. Using time of final payment for the day
                                    + ",Mining,,,EBX,"
                                    + ebxTotalForDay
                                    + ",,,"
                                    + marketValueCurrency + ","
                                    + (includeMarketValue ? dollarsToday : "")
                                    + ",,,")
                                    //+ txId)
          }
    }
    console.warn("total EBX:                 ", (totalAdams / 100000000000))
    console.warn("ALTERNATIVE running count: ", alternativeRunningCount)
    console.error("Total DOLLARS: $" + totalDollars)

    // build TEXT file, then save it
    if ( exportToCSV && entriesToExport.length > 0 ) {
        console.warn("We've got some data (" + entriesToExport.length + " rows) to review, then export")
        let fileText = ""
        let i = 0
        for ( const entry of entriesToExport ) {
          console.warn("Entry " + i + ":", entry)
          fileText += (entry + "\n")
          i++
        }
  
        console.error("Here's the EBX CSV file we're going to export:\n" + fileText)
        //alert(" okay?")
  
        this.exportCoinsToCsvFile(fileText)
    }

  }

  async analyzeDeposits() {
    // don't allow user to initiated a new query while one is ongoing
    this.setState({disableButtons: true})

    console.warn("start date limit: ", this.state.startDateLimit)
    console.warn("end date limit: ", this.state.endDateLimit)
    //alert("now is the time to analyze the deposits data...")


    let startDateLimit = null
    let startLimitMention = null
    if ( this.state.limitStartDate ) {
      startDateLimit = this.state.startDateLimit
      startLimitMention = <>
                      We only included payments <b>on or after</b> <span style={{color:'blue'}}>{this.state.startDateLimit}</span>
                      <br></br>
                    </>
    }

    let endDateLimit = null
    let endLimitMention = null
    if ( this.state.limitEndDate ) {
      endDateLimit = this.state.endDateLimit
      endLimitMention = <>
                      We only included payments <b>before</b> <span style={{color:'blue'}}>{this.state.endDateLimit}</span>
                      <br></br>
                    </>
    }

    //                                                                       export, lump, includeMarketValue
    const results = await this.reviewDeposits([], startDateLimit, endDateLimit, true, true, true)


    console.log("reviewing deposits:")
    console.log("results of review: ", results)

    this.setState({disableButtons: false})

  }

  showClearData() {
    this.setState({showClearDataModal: true})
  }
  hideClearData(){
    this.setState({showClearDataModal: false})
  }
  async actuallyDeleteData() {
    alert("We're about to delete the EBX deposit data (from the browser DB)...")
    deleteSetting(await openDB(), ebx_deposits_idb_label)
    alert("The EBX deposit data has been removed from the browser DB")
    this.hideClearData()
  }

  showAnalysis() {
    this.setState({showAnalysisModal: true})
  }
  hideAnalysis() {
    this.setState({showAnalysisModal: false,  disableButtons: false})
  }


  editStartDate() {
    console.log("editStartDate() BTW: startDateLimit: ", this.state.startDateLimit)
    console.log("editStartDate() BTW: rawStartDateValue: ", this.state.rawStartDateValue)

    this.setState({showStartDateSetter: true})
  }
  toggleStartDateLimit() {
    console.log("toggleStartDateLimit() BTW: startDateLimit: ", this.state.startDateLimit)
    console.log("toggleStartDateLimit() BTW: rawStartDateValue: ", this.state.rawStartDateValue)

    if ( this.state.startDateLimit === null ) {
      console.warn("start date string was null, so, let's display the modal - BUT, disable the SET")

      this.setState({showStartDateSetter: true, disableSetStartDateButton: true})
    } else if ( this.state.showStartDateSetter ) {
      console.warn("start date string was NOT null, but, showStartDateSetter was true, so, CLOSING the START date the modal")
      this.setState({showStartDateSetter: false})
    } else if ( this.state.limitStartDate ) {
      console.warn("start date string was NOT null, AND, showStartDateSetter was false, BUT limitStartDate was true, so, maybe CLEAR the limit box")
      this.setState({limitStartDate: false})
      return
    } else {
      console.warn("limitStartDate was false, so, just CHECK the box?")
      this.setState({limitStartDate: true})
      return
    }

    //console.log("PROCEEDING")

    this.setState({limitStartDate: !this.state.limitStartDate })
  }
  toggleShowStartDateModal() {
    console.log("toggleShowStartDateModal()  - just the MODAL")
    this.setState({ showStartDateSetter: !this.state.showStartDateSetter})
  }
  onStartDateChange(event, data) {
    console.log("onStartDateChange():   value: ", data.value)

    console.log("  OLD start date limit: ", this.state.startDateLimit)

    const newDate = new Date(data.value).toISOString().split('T')[0]
    console.log("  New start date limit: ", newDate)

    const disableSet = "1970-01-01" === newDate

    this.setState({startDateLimit: newDate, disableSetStartDateButton: disableSet, rawStartDateValue: data.value});
  }

  editEndDate() {
    console.log("editEndDate() BTW: endDateLimit: ", this.state.endDateLimit)
    console.log("editEndDate() BTW: rawEndDateValue: ", this.state.rawEndDateValue)

    this.setState({showEndDateSetter: true})
  }
  toggleEndDateLimit() {
    console.log("toggleEndDateLimit() BTW: endDateLimit: ", this.state.endDateLimit)
    console.log("toggleEndDateLimit() BTW: rawEndDateValue: ", this.state.rawEndDateValue)

    if ( this.state.endDateLimit === null ) {
      console.warn("end date string was null, so, let's display the modal - BUT, disable the SET")

      this.setState({showEndDateSetter: true, disableSetEndDateButton: true})
    } else if ( this.state.showEndDateSetter ) {
      console.warn("end date string was NOT null, but, showEndDateSetter was true, so, CLOSING the date the modal")
      this.setState({showEndDateSetter: false})
    } else if ( this.state.limitEndDate ) {
      console.warn("end date string was NOT null, AND, showEndDateSetter was false, BUT limitEndDate was true, so, maybe CLEAR the limit box")
      this.setState({limitEndDate: false})
      return
    } else {
      console.warn("limitEndDate was false, so, just CHECK the box?")
      this.setState({limitEndDate: true})
      return
    }

    //console.log("PROCEEDING")

    this.setState({limitEndDate: !this.state.limitEndDate })
  }
  toggleShowEndDateModal() {
    console.log("toggleShowEndDateModal()  - just the MODAL")
    this.setState({ showEndDateSetter: !this.state.showEndDateSetter})
  }
  onEndDateChange(event, data) {
    console.log("onEndDateChange():   value: ", data.value)

    console.log("  OLD end date limit: ", this.state.endDateLimit)

    const newDate = new Date(data.value).toISOString().split('T')[0]
    console.log("  New end date limit: ", newDate)

    const disableSet = "1970-01-01" === newDate

    this.setState({endDateLimit: newDate, disableSetEndDateButton: disableSet, rawEndDateValue: data.value});
  }

  componentWillUnmount() {
    //alert("REMOVING listener...")
//    document.getElementById('inputFileHolder')?.removeEventListener('change', this.walletReaderFunc)
  }

  componentDidMount() {
//    this.setState({enableInspectButton: false, numItemsToImport: ' ', invalidImportFile: false});

    //alert("ADDING listener...")
//    document.getElementById('inputFileHolder').addEventListener('change', this.walletReaderFunc);


    //FIXME: it's when we enable/disable the paste button that this 'inputFileHolder' comes into and out of existence
  }

  walletReaderFunc(e) {
    const parent = e.currentTarget
    const myEbxDepositsImporter = this
    const fr = new FileReader();

    fr.onload=function(){
        // PLACE the contents we've read into a 'nook' which the solicitPassword() will use
        document.getElementById('contentPlaceHolder').textContent = fr.result;
        const jsonString = document.getElementById('contentPlaceHolder').innerHTML;
        console.log("placed content of length " + jsonString.length);
        try {
          const contents = JSON.parse(jsonString)
          console.warn(' ')
          console.log(" here's the JSON file we've loaded: ", jsonString)
          console.warn(" ")
          console.log("number of elements: ", contents.length);
          myEbxDepositsImporter.setState({enableInspectButton: true, numItemsToImport: (' ' + contents.length)});
          myEbxDepositsImporter.setState({invalidImportFile: false});
        } catch (error) {
          console.warn(' ')
          console.log(" here's the file: ", jsonString)
          console.warn(" ")
          console.log("invalid encrypted-key import file: ", error);
          myEbxDepositsImporter.setState({invalidImportFile: true});
        }
    }

    fr.readAsText(parent.files[0]);
  }

  handlePwdChange(event) {
    //console.log("handlePwdChange(): pwd now set to ", event.target.value);

    this.setState({pwd: event.target.value});
  }
  // NOTE: COPIED from keyUtil.js  handleBsvKeySaverSave(), and walletGenerator's handleBsvKeySave()
  async handleBsvKey() {

        const addressToSave = bsv.PrivateKey.fromWIF( this.state.priv ).toAddress().toString()
        console.log("handleBsvKeySave(): address is ", addressToSave);

    //console.log("pwd is ", this.state.pwd);

        const bundled = {p: this.state.priv, address: addressToSave}
        const bundledPlainText = JSON.stringify(bundled);
    //console.log("bundled plain text is", bundledPlainText);

        let cyphText
        try {
          cyphText = await encryptData(bundledPlainText, this.state.pwd);
        } catch (error) {
          alert("Please make sure you're using https://")
          throw error
        }

        console.log("cypher text is ", cyphText);
        //console.warn("That cypher/blob was generated with pwd " + this.state.pwd)

        try {
            const db = await openDB();
            //NOTE: saves as an 'officialWallet' (testnet)
            await saveEncryptedP2PKHKey(db, addressToSave, cyphText, true, 't', 1);

            console.warn("we've saved the encrypted p2pkh key")
            alert("Imported / created-from-scratch")

            this.props.userNowHasWallet();
        } catch (error) {
//FIXME: did this ever work? we have no such props - yet
            /*
            this.props.showOkModal("Wallet Save FAILED",
            <>
                <p>
                    Something went wrong. Your wallet was NOT saved. Do NOT use the wallet's address (shown earlier).
                </p>
                <p>
                    Please report this.
                </p>
            </>)
            */
            alert("Something went wrong. Your wallet was NOT saved. Do NOT use that address: ", error)
            //FIXME: now what? Maybe offer ideas, and close THIS modal
        }

        // close the pop-up
        //           this.props.parent.setState({openBsvKeySaverModal: false, pwd: ''});
  }


  // user pasted gibberish, or retrieved from a file
  async solicitPassword( jsonContentString ) {
    //const jsonContentString = document.getElementById('contentPlaceHolder').innerHTML;

    console.log("here is the content string: ", jsonContentString)
    const contents = JSON.parse(jsonContentString)



//FIXME: can the json FAIL to parse


    //const walletVersion = contents.bshzWalletVersion
    //const walletNetwork = contents.network
    //const walletBlob    = contents.blob
    //const walletCreated = contents.created

    //console.log("Imported wallet version: ", walletVersion)
    //console.log("Imported wallet network: ", walletNetwork)
    console.log("Imported wallet blob: ", contents)

    this.setState({
                    importClicked: true,      // disables the IMPORT button

                    showPasswordInputField: true,

                    walletGibberish: jsonContentString,

                    walletVersion: 1,
                    walletNetwork: 2,
                    walletCreated: 3,
                    walletBlob:    contents,
                  })
  }

  //NOTE: copied from keyImporter's inspectContents()
  //NOTE: used for both publisher rabins, and builder rabins (called twice)
  async importRabinKeys(rabinKeyRecords, variant=null) {

    //NOTE: we don't use variant
    const recordsType = variant === "null" ? "Publisher" : "Builder"

    console.warn("importRabinKeys() " + recordsType + " records: ", rabinKeyRecords)

    const jsonContentString = rabinKeyRecords;
    console.log("here is the RABIN record content string: ", jsonContentString)
    const contents = JSON.parse(jsonContentString)
    console.log("number of elements: ", contents.length);
    let eachHasPkh = true;
    let eachHasBlob = true;
    let eachHasAlloc = true;

    //FIXME: in order for this to work,
    //       we need to solicit the WALLET pwd - not the FILE pwd
    const checkEachKey = false

    let i = 0;
    contents.forEach(element => {
      console.log("element.pkh: ", element.pkh);
      console.log("element.blob: ", element.blob);
      console.log("element.alloc: ", element.alloc);
      if ( !element.pkh ) {
        console.log("There is no pkh for " + i);
        eachHasPkh = false;
      }
      if ( !element.blob ) {
        console.log("There is no blob for " + i);
        eachHasBlob = false;
      }
      if ( element.alloc === undefined && typeof element.alloc == 'undefined' ) {
        console.log("There is no alloc for " + i);
        eachHasAlloc = false;
      }
      i++;
    });
    console.log("There are " + i + " elements")

    let successfulImports = 0
    if ( eachHasPkh && eachHasBlob && eachHasAlloc ) {
      console.log("suitable. will import " + i + " entries (rabin)");
      var db = await openDB();

      for ( var j = 0; j < i; j++ ) {
        const pkh = contents[j].pkh;

        // does this pkh entry already have a record? Don't overwrite
        let x = await getEncryptedKeysFromPKH(db, pkh, variant);
        console.log("record for given pkh (", pkh, "): ", x);

        if ( x && x !== null ) {
          console.log("There's already an entry for pkh " + pkh + ". SKIPPING");
        } else {
          console.log("IMPORTING record for pkh " + pkh);
          saveEncryptedKeys(db, pkh, contents[j].blob, variant, contents[j].alloc);
          successfulImports++;

          if ( checkEachKey ) {
            try {
              //FIXME: this requires the WALLET pwd - not the FILE pwd
              const plainBundle = await decryptData(contents[j].blob, this.state.pwd);

              //console.log("importRabinKeys(): decrypted json string:", plainBundle);

              const bundledObject = JSON.parse(plainBundle);
              //console.log("decrypted bundle: ", bundledObject)
            } catch (error) {
              console.error("importRabinKeys(): Bad decrypt. Probably provided wrong password.");
              alert("trouble while importing a Publisher key")
              break;
            }
          }

        }
      };

      console.log("Imported " + successfulImports + " of "+ i
                + " " + recordsType
                + " rabin keys");
    } else {
      console.log("Since not all entries had all the required fields, we won't import the contents of this file.")
      alert("WARNING: There was something wrong with the " + recordsType + " records in this file, so, we didn't import ANY of them.")
    }

    return successfulImports
  }

  // This might be outdated - from when the wallet was JUST an 'official' funding key
  //async inspectContents(event) {
  //  event.preventDefault()

  //  await this.importFundingKey(this.state.walletBlob)
  //}

  async importFundingKey(officialRecord) {

    console.warn("importFundingKey() officialFundsRecord: ", officialRecord)

    const contents = JSON.parse( officialRecord )

    //NOTE: methinks there's only ONE 'official' record anyway
    let eachHasAddress = true;
    let eachHasBlob = true;
    let eachHasAlloc = true;

    let successfulFundingImports = 0;
    let keysSkipped = 0;
    let hasPriv = false;
    let priv = null

    let i = 0;
    contents.forEach(element => {
      // outdated logic - probably copied from rabin-handling code
      if ( element.privk ) {
        alert("import has private key");
        hasPriv = true
        priv = element.privk
      }

      console.log("element.address: ", element.address);
      console.log("element.blob: ", element.blob);
      if ( !element.address ) {
        console.log("There is no address for " + i);
        eachHasAddress = false;
      }
      if ( !element.blob ) {
        console.log("There is no blob for " + i);
        eachHasBlob = false;
      }
      /*
      console.log(" element.alloc: " + element.alloc)
      if ( element.alloc === undefined && typeof element.alloc == 'undefined' ) {
        console.log("There is no alloc for " + i);
        eachHasAlloc = false;
      }
      */
      i++;
    });
    console.log("There are " + i + " elements")

    if ( hasPriv ) {  //NOTE: might not be used. Vestige from rabin-handling code?
      //await handleBsvKey(priv)
      this.setState({getPwdForPriv: true, priv: priv})
    } else if ( eachHasAddress && eachHasBlob && eachHasAlloc) {
      console.log("suitable. will import " + i + " entries (funding)");
      var db = await openDB();

      for ( var j = 0; j < i; j++ ) {
        const address = contents[j].address;

        // does this address entry already have a record? Don't overwrite
        let x = await getEncryptedKeysFromAddress(db, address);
        console.log("EXISTING (if any) record for given address (", address, "): ", x);

        if ( x && x !== null ) {
          console.log("There's already an entry for address " + address + ". SKIPPING");
          keysSkipped++;
        } else {
          console.log("IMPORTING record for address " + address);
          saveEncryptedWallet(db, address, contents[j].blob);
          successfulFundingImports++;
        }
      };

      console.log("Imported " + successfulFundingImports + " of " + i + " wallet FUNDING keys");

      // This part was moved to useEnteredPasswordToDecrypt(), where SUCCESS is if we loaded at least 1 funding key
      /*
      this.setState({ showOkModal: true,
                    keysSkipped: keysSkipped
                  })

      this.props.userNowHasWallet();
      */
      this.setState({ keysSkipped: keysSkipped })

    } else {
      console.warn("Since not all entries had all the required fields, we won't import the contents of this file.")
      alert("WARNING: this file has some missing, or unrecognized fields. Decryption declined.")
    }

    return successfulFundingImports

  } // importFundingKey

  //FIXME: this was copied from importFundingKey(). We can probably extract shared logic

  async importPayoutKeys(records) {

    //NOTE: slight difference with importFUndinKey() - parsing string,
    //      and also two similar DB function calls
    //const contents = JSON.parse( payoutRecords )

    let eachHasAddress = true;
    let eachHasBlob = true;
    let eachHasAlloc = true;

    let successfulKeyImports = 0;
    let keysSkipped = 0;

    //FIXME: in order for this to work,
    //       we need to solicit the WALLET pwd - not the FILE pwd
    const checkEachKey = false

    let i = 0;
    records.forEach(element => {

      console.log("element.address: ", element.address);
      console.log("element.blob: ", element.blob);
      console.log("element.alloc: ", element.alloc);
      if ( !element.address ) {
        console.log("There is no address for " + i);
        eachHasAddress = false;
      }
      if ( !element.blob ) {
        console.log("There is no blob for " + i);
        eachHasBlob = false;
      }
      if ( element.alloc === undefined && typeof element.alloc == 'undefined' ) {
        console.log("There is no alloc for " + i);
        eachHasAlloc = false;
      }
      i++;
    });
    console.log("There are " + i + " payout elements")

    if ( eachHasAddress && eachHasBlob && eachHasAlloc ) {
      console.log("suitable. will import " + i + " payout entries");
      var db = await openDB();

      for ( var j = 0; j < i; j++ ) {
        const address = records[j].address;

        // does this address entry already have a record? Don't overwrite
        //NOTE: super-similar name - getEncryptedKeysFromAddress()
        let x = await getEncryptedKeyFromAddress(db, address);
        console.log("EXISTING (if any) record for given address (", address, "): ", x);

        if ( x && x !== null ) {
          console.log("There's already an entry for address " + address + ". SKIPPING");
          keysSkipped++;
        } else {
          console.log("IMPORTING record for address " + address);
          //await saveEncryptedWallet(db, address, contents[j].blob);  //official
          await saveEncryptedP2PKHKey(db, address, records[j].blob, false, 't', records[j].alloc);
          successfulKeyImports++;


          if ( checkEachKey ) {
            try {
              //FIXME: this requires the WALLET pwd - not the FILE pwd
              const plainBundle = await decryptData(records[j].blob, this.state.pwd);

              //console.log("importPayoutKeys(): decrypted json string:", plainBundle);

              const bundledObject = JSON.parse(plainBundle);
              //console.log("decrypted bundle: ", bundledObject)
            } catch (error) {
              console.error("importPayoutKeys(): Bad decrypt. Probably provided wrong password.");
              alert("trouble while importing a Payout key")
              break;
            }
          }
        }
      };

      console.log("Imported " + successfulKeyImports + " of " + i + " payout keys");

    } else {
      console.warn("Since not all Payout entries had all the required fields, we won't import the contents of this file.")
      alert("WARNING: these Payout records have some missing, or unrecognized fields. Decryption declined.")
    }

    return successfulKeyImports

  } // importPayoutKeys

  // adapted from importPayoutKeys()
  async importDomainsClaimed(records) {

    let eachHasName = true;
    let eachHasOwnerCount = true;

    let successfulKeyImports = 0


    let i = 0;
    records.forEach(element => {

      console.log("element.name: ", element.name);
      console.log("element.ownerCount: ", element.ownerCount);
      if ( !element.name ) {
        console.log("There is no name for " + i);
        eachHasName = false;
      }
      if ( !element.ownerCount ) {
        console.log("There is no ownerCount for " + i);
        eachHasOwnerCount = false;
      }
      i++;
    });
    console.log("There are " + i + " domain elements")

    if ( eachHasName && eachHasOwnerCount ) {
      console.log("suitable. will import " + i + " domain entries");
      var db = await openDB();

      for ( var j = 0; j < i; j++ ) {
        const name = records[j].name;

          console.log("IMPORTING record for domain " + name);

          // NEW field. Fill it in, if missing (for now)
          const approxBlockHeightWhenRegistered = records[j].approxBlockHeight //? records[j].approxBlockHeight : 1517450

          //saveEncryptedWallet(db, address, contents[j].blob);  //official
          registerDomainOfMine(db, name, records[j].ownerCount, approxBlockHeightWhenRegistered, records[j].outdated);
          successfulKeyImports++
      };

      console.log("Imported " + successfulKeyImports + " of " + i + " domains");

    } else {
      console.warn("Since not all domain entries had all the required fields, we won't import the contents of this file.")
      alert("WARNING: these domain records have some missing, or unrecognized fields. IMPORT declined.")
    }

    // actually, records: name, ownerCount, approxBlockHeight, flag
    return successfulKeyImports
  } // importDomainsClaimed

  // adapted from importPayoutKeys()
  async importDomainsBuilt(records) {

    let eachHasName = true;
    let eachHasPayout = true;
    let eachHasRabin = true
    let eachHasTxId = true

    let successfulKeyImports = 0

    let i = 0;
    records.forEach(element => {

      console.log("element.name: ", element.name);
      console.log("element.payout: ", element.payout);
      console.log("element.rabin: ", element.rabin);
      console.log("element.txid: ", element.txid);
      if ( !element.name ) {
        console.log("There is no name for " + i);
        eachHasName = false;
      }
      if ( !element.payout ) {
        console.log("There is no payout for " + i);
        eachHasPayout = false;
      }
      if ( !element.rabin ) {
        console.log("There is no rabin for " + i);
        eachHasRabin = false;
      }
      if ( !element.txid ) {
        console.log("There is no txid for " + i);
        eachHasTxId = false;
      }

      i++;
    });
    console.log("There are " + i + " domainsBuilt elements")

    if ( eachHasName && eachHasPayout && eachHasRabin && eachHasTxId ) {
      console.log("suitable. will import " + i + " domainsBuilt entries");
      var db = await openDB();

      for ( var j = 0; j < i; j++ ) {
        const name = records[j].name;

          console.log("IMPORTING domainsBuilt record for domain " + name);
          //saveEncryptedWallet(db, address, contents[j].blob);  //official
          registerBuiltDomain(db, name, records[j].payout, records[j].rabin, records[j].txid);
          successfulKeyImports++
      };

      console.log("Imported " + successfulKeyImports + " of " + i + " domainsBuilt");

    } else {
      console.warn("Since not all domain entries had all the required fields, we won't import the contents of this file.")
      alert("WARNING: these domain records have some missing, or unrecognized fields. IMPORT declined.")
    }

    // actually, records: name, payoutP2PKH, rabin, txid
    return successfulKeyImports
  }

  //NOTE: this was taken from WalletVerifier, and adapted for use here
  async useEnteredPasswordToDecrypt(event) {
    event.preventDefault();

    // show the fleeting modal
  //  this.setState({showImportSwirly: true})

    //const walletRecord = await this.props.getOfficialWallet();

    console.warn("useEnteredPasswordToDecrypt(): attempt to decrypt wallet blob. record: ", this.state.walletBlob)

    let tampered = false

    let eachHasAmt = true;
    let eachHasAdams = true
    let eachHasDate = true;
    let eachHasTime = true;

    //console.warn("P: ", this.state.pwd)
    try {
        const contents = this.state.walletBlob
 //       const plainBundle = this.state.walletBlob //await decryptData(this.state.walletBlob, this.state.pwd);

        //console.warn("useEnteredPasswordToDecrypt(): plainBundle", plainBundle)
        //alert("useEnteredPasswordToDecrypt(): we were able to decrypt wallet blob!")

        //console.log("here is the decrypted string: ", plainBundle)
//        const contents = JSON.parse(plainBundle)
        console.warn("Here's the json-parsed structure: ", contents)
        console.warn("it has length of ", contents.length)


        let i = 0;
        contents.forEach(element => {
    
          console.log("element.amt: ", element.amt);
          console.log("element.adams: ", element.adams);
          console.log("element.date: ", element.date);
          console.log("element.time: ", element.time);
          if ( !element.amt ) {
            console.log("There is no amt for " + i);
            eachHasAmt = false;
          }
          if ( !element.adams ) {
            console.log("There is no adams for " + i);
            eachHasAdams = false;
          }
          if ( !element.date ) {
            console.log("There is no date for " + i);
            eachHasDate = false;
          }
          if ( element.time === undefined && typeof element.alloc == 'undefined' ) {
            console.log("There is no time for " + i);
            eachHasTime = false;
          }
          i++;
        });
        console.warn("There are " + i + " EBX deposit elements")

        if ( !eachHasAmt || !eachHasAdams || !eachHasDate || ! eachHasTime ) {
            throw new Error("At least one of these fields was missing for at least one of the entries: amt, adams, date, time")
        }

        const ebxDepositsString = JSON.stringify( contents )
        await saveSetting(await openDB(), ebx_deposits_idb_label, ebxDepositsString)

        return

        // From WalletExporter

        //const bundleToEncrypt = {
        //  bundleTime:        Date(),
        //  officialFunds:     [],
        //  publisherKeys:     [],
        //  builderPayoutKeys: [],
        //  domainsBuilt:      [],
        //  domainsClaimed:    [],
        //}
/*
        const bundleTime        = contents.bundleTime
        const officialFunds     = contents.officialFunds
        const publisherKeys     = contents.publisherKeys
        const builderPayoutKeys = contents.builderPayoutKeys
        //const builderRabins     = contents.builderRabins
        const domainsBuilt      = contents.domainsBuilt
        const domainsClaimed    = contents.domainsClaimed
        //console.warn("IMPORTED officialFunds: ", officialFunds)
        //console.warn("IMPORTED publisherKeys: ", publisherKeys)
        //console.warn("IMPORTED builderPayoutKeys: ", builderPayoutKeys)
        //console.warn("IMPORTED builderRabins: ", builderRabins)
        console.warn("IMPORTED domainsBuilt: ", domainsBuilt)
        console.warn("IMPORTED domainsClaimed: ", domainsClaimed)

        console.warn("envelope 'create' timestamp: ", this.state.walletCreated)
        console.warn("decrypted 'bundleTime': ", bundleTime)
    /*
        if ( bundleTime !== this.state.walletCreated ) {
          tampered = true
          console.error("Wallet tampering/corruption detected? Decrypted 'bundleTime' doesn't match the envelope 'created' timestamp")
          throw new Error("mismatch in timestamps")
        }
    */

        const payoutCount = await this.importPayoutKeys( builderPayoutKeys )
        const rabinCount = await this.importRabinKeys( publisherKeys )
        //await this.importRabinKeys( builderRabins, "builder" )

        const domainsBuiltCount = await this.importDomainsBuilt( domainsBuilt )       // name, payout, rabin, txid
        const domainsClaimedCount = await this.importDomainsClaimed( domainsClaimed )    // name, ownerCount (number)

        const fundingKeysCount = await this.importFundingKey( officialFunds )

        console.warn("funds records: " + fundingKeysCount)
        console.warn("payout records: " + payoutCount)
        console.warn("rabin records: " + rabinCount)
        console.warn("claimed records: " + domainsClaimedCount)
        console.warn("built domains: " + domainsBuiltCount)
        const totalElementCount = fundingKeysCount +
                                  payoutCount +
                                  rabinCount +
                                  domainsClaimedCount +
                                  domainsBuiltCount
        console.warn("total records: " + totalElementCount)

        this.setState({totalRecordsCount: totalElementCount})

        // logic moved from importFundingKey() (called above)
        if ( fundingKeysCount > 0 ) {
          this.setState({ showOkModal: true })

          this.props.userNowHasWallet();
        } else {
          alert("We imported ZERO funding keys, so we consider the import a FAILURE.\nPlease check your wallet backup.")
        }

    } catch (error) {
      if ( tampered ) {
        console.warn("File tampered-with?", error)
        /*
        this.props.showOkModal("File tampering or corruption",
                              <>
                                We don't like this file. The envelope timestamp doesn't match the decrypted contents.
                                <br></br>
                                Where have you been storing this file?
                              </>)
        */
      } else {
        console.warn("Invalid file format? ", error)
        /*
        this.props.showOkModal("Wrong Password", <>You've entered the <span style={{color: "red"}}>wrong password</span> for
                                                    your wallet, OR, you've selected the <span style={{color: "red"}}>wrong
                                                    file</span>, OR, <span style={{color: "red"}}>you're not using
                                                    https://</span>. Please check, and try again.</>)
        */

        // set-up for user to try again
        this.setState({ enablePaste: true, pwd: '', showPasswordInputField: false, importClicked: false,
                        disablePasteButton:true,     //needed?
                        enableInspectButton2: false  //needed?
                      })
      }
      this.setState({pwd: '', showImportSwirly: false});
    }
  }


  render() {

    //FIXME: Copied from onramp.js.   can we share this somehow?
    // ***  DEVICE-DEPENDENT STYLING  ***
    // For mobile, "detect" landscape screen mode
    const landscape = this.props.isMobile ? window.innerWidth > window.innerHeight : false
    // For mobile, shrink the About, Security, and Glossary modals
    const modalClassName   = this.props.isMobile ?
                                    (landscape ?
                                            "modalMobileLandscape"
                                        :
                                            "modalMobilePortrait"
                                    )
                                :
                                    ""
    const modalContentClassName = this.props.isMobile ? "modalContentMobile" : ""
    const modalBottomClassName  = this.props.isMobile ? "modalBottomMobile"  : ""

    //FIXME: future: indicate how many keys are read

    //    early attempts
    //    <Button field="import" onClick={this.handleImport} positive>Import Password-Encrypted Keys</Button>
    //    <input type="file" accept=".txt" onChange={this.handleFileImport} />

    //FIXME: style the input button: https://www.w3docs.com/tools/code-editor/6961
    //       style, AND hide: https://stackoverflow.com/questions/36540105/how-to-style-a-choose-file-button-using-css-only

    const keyWord = this.state.numItemsToImport === ' 1' ? 'key' : 'keys';

    const invalidWarning = this.state.invalidImportFile ?
                            <div style={{color: 'red'}}>Invalid import file</div>
                            : null;

    const importButtonLabel2 = this.state.invalidImportFile2 ?
                            "IMPORT the ebx deposits from this JSON"
                          :
                            "IMPORT ebx deposits from this JSON"
//                            "IMPORT" + this.state.numItemsToImport2 + " " + keyWord + " from this gibberish";

    const textBox = this.state.enablePaste ?
                    <>
                      <TextArea maxLength="300000"
                                style={{width: "100%", minHeight: 150}}
                                placeholder="Paste your backed-up wallet gibberish/text here"
                                onChange={this.handlePaste}/>
                      <Button field="inspect" disabled={!this.state.enableInspectButton2 || this.state.invalidImportFile2 || this.state.importClicked}
                          onClick={() => this.solicitPassword(this.state.pastedContents)} positive>
                          {importButtonLabel2}
                      </Button>
                    </>
                  :
                    <></>

    const skippedKeysMention = this.state.keysSkipped > 0 ?
                            <>
                              <br></br><br></br>
                              {this.state.keysSkipped} of the key(s) were skipped - because they were duplicates.
                            </>
                        :
                            <></>

    //NOTE: might not be used - vestige from rabin-handling code
    const disableSave = this.state.pwd.length < 8
    const encryptPriv = this.state.getPwdForPriv ?   //NOTE: might not be used
            <>
                <div>
                    We've IMPORTED a Bitcoin private key for you. We'll use it once you've encrypted your wallet with a password, saved it to your browser, and verified you can retrieve (and decrypt) it.
                </div>
                <br></br>

                <Form>
                    Please enter a strong password (at least 8 chars):<br></br>
                    <Input style={{width:'300px'}} onChange={this.handlePwdChange}
                            placeholder="Enter a password to protect your wallet">
                      <input style={{borderRadius: '50px'}} />
                    </Input> <br></br>
                    <Button disabled={disableSave} field="saveButton" onClick={this.handleBsvKey} positive>ENCRYPT my key. I've written down my password.</Button>
                </Form>
            </>
          :
            null


        const disableCheckButton = this.state.pwd.length < 8;
        const verifierTextB =
            <>
                <p>
                    We can't import this wallet file until you've entered the <b style={{color:"blue"}}>file</b> password.
                </p>

                <Form>
                    Please enter the <b style={{color: "blue"}}>file</b> password (at least 8 chars) you used to save/export/encrypt this wallet gibberish:<br></br>
                    <Input value={this.state.pwd} style={{width:'300px'}} onChange={this.handlePwdChange} autoFocus
                            placeholder="Enter your wallet FILE password">
                      <input style={{borderRadius: '50px'}} />
                    </Input> <br></br>
                    <Button disabled={disableCheckButton} field="checkButton" onClick={this.useEnteredPasswordToDecrypt} positive>
                        Go ahead and import (we used to decrypt now)
                    </Button>
                </Form>
            </>

        const verifierText = this.state.showPasswordInputField ? verifierTextB : <></>;

        //FIXME: check if this file is invalid
        const firstMethod = this.state.disablePasteButton ?
                    <></>
                :
                    <>
                      <p>
                        <b>1 - Use a file you've saved</b>
                        <br></br>
                        Please select the file which you've used to backup your wallet. It's been encrypted with a password you provided.
                        <br></br>
                        <input type="file" name="inputFileHolder" id="inputFileHolder" />
                        <Button field="inspect" disabled={!this.state.enableInspectButton || this.state.invalidImportFile}
                                onClick={() => this.solicitPassword(document.getElementById('contentPlaceHolder').innerHTML)} positive>
                            Use this Wallet File
                        </Button>
                      </p>
                    </>
        const secondMethod = this.state.enableInspectButton ?
                    <></>
                :
                    <>
                      <p>
                        <b>2 - Use the raw JSON (copy, paste it from clipboard)</b>
                        <br></br><br></br>
                        <Button disabled={this.state.disablePasteButton} onClick={this.allowPaste} positive autoFocus>
                            Use the raw JSON
                        </Button>

                        {textBox}
                      </p>
                    </>
        
        const importerModal = 
                this.state.showImporterModal ?
                    <Modal size='small' centered className={modalClassName}  open={true} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                        <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                            <span style={{color: this.bshzYellow}}> Import EBX Deposits </span>
                        </Modal.Header>
                        <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>
                            There are two ways to import EBX deposits.
                            <p></p>

                            {firstMethod}
                            <p></p>
                            {invalidWarning}

                            <br></br>
                            {secondMethod}
                            {verifierText}

                            {encryptPriv}

                            <p></p>
                            <Divider />
                            <Button field="cancelButton" onClick={this.disappearImporter} negative>CANCEL</Button>

                            <pre id="contentPlaceHolder" style={{display:'none'}}></pre>
                        </Modal.Content>
                    </Modal>
                :
                    <>
                    </>



        const startDateToShow = this.state.limitStartDate ?
                <b style={{color:'blue'}}>
                    {this.state.startDateLimit}
                </b>
                :
                this.state.startDateLimit !== null ?
                    <span style={{color:'grey'}}>
                        {this.state.startDateLimit}
                    </span>
                    :
                    <></>//'is null'
        const endDateToShow = this.state.limitEndDate ?
                <b style={{color:'blue'}}>
                    {this.state.endDateLimit}
                </b>
                :
                this.state.endDateLimit !== null ?
                    <span style={{color:'grey'}}>
                        {this.state.endDateLimit}
                    </span>
                    :
                    <></>//'is null'
        const maybeEditStartButton = this.state.limitStartDate && typeof this.state.rawStartDateValue !== undefined ?
                <>
                &nbsp; <Button onClick={this.editStartDate} content="Edit" style={{backgroundColor:'blue', color:'yellow', borderRadius: '15px', padding:'7px'}}/>
                </>
            :
                null
        const maybeEditEndButton = this.state.limitEndDate && typeof this.state.rawEndDateValue !== undefined ?
                <>
                &nbsp; <Button onClick={this.editEndDate} content="Edit" style={{backgroundColor:'blue', color:'yellow', borderRadius: '15px', padding:'7px'}}/>
                </>
            :
                null
        const limitStartDateCheckbox = this.state.disableButtons ?
                <>
                    <Checkbox label='Limit start date' checked={false} disabled />
                    &nbsp; &nbsp;{startDateToShow}
                </>
                :
                <>
                    <Checkbox label='Limit start date' checked={this.state.limitStartDate} onClick={this.toggleStartDateLimit}/>
                    &nbsp; &nbsp;{startDateToShow} {maybeEditStartButton}
                </>
        const limitEndDateCheckbox = this.state.disableButtons ?
                <>
                    <Checkbox label='Limit end date' checked={false} disabled />
                    &nbsp; &nbsp;{endDateToShow}
                </>
                :
                <>
                    <Checkbox label='Limit end date' checked={this.state.limitEndDate} onClick={this.toggleEndDateLimit}/>
                    &nbsp; &nbsp;{endDateToShow} {maybeEditEndButton}
                </>




        const clearStartDate = () => this.setState({startDateLimit: null, showStartDateSetter: false, limitStartDate: false, rawStartDateValue: undefined});

        const maybeShowStartDateSetter =
            <Modal size='small' centered className={modalClassName}  open={this.state.showStartDateSetter} style={{backgroundColor: bshzColors.purple, borderRadius: '20px'}}>

                <Modal.Header style={{textAlign: 'center', backgroundColor: bshzColors.purple, borderRadius: '20px'}}>
                    <span style={{color: bshzColors.yellow}}> Set Payment Review Start Date LIMIT</span>
                </Modal.Header>

                <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: bshzColors.ltPurple}}>

                    <br></br>
                    Enter the first date you want the review/analysis to include:
                    <br></br>
                    <SemanticDatepicker
                        onChange={this.onStartDateChange}
                        format="YYYY-MM-DD"
                        value={this.state.rawStartDateValue}
                        keepOpenOnClear={true}
                        filterDate={this.checkFilterStartDate}
                    /> &nbsp;
                    <Button onClick={this.toggleShowStartDateModal}
                                    content='SET' positive disabled={this.state.disableSetStartDateButton}/>
                    <Button onClick={clearStartDate}
                                    content='Clear/Cancel' negative/>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                </Modal.Content>

            </Modal>

        const clearEndDate = () => this.setState({endDateLimit: null, showEndDateSetter: false, limitEndDate: false, rawEndDateValue: undefined});

        const maybeShowEndDateSetter =
            <Modal size='small' centered className={modalClassName}  open={this.state.showEndDateSetter} style={{backgroundColor: bshzColors.purple, borderRadius: '20px'}}>

                <Modal.Header style={{textAlign: 'center', backgroundColor: bshzColors.purple, borderRadius: '20px'}}>
                    <span style={{color: bshzColors.yellow}}> Set Payment Review Date LIMIT</span>
                </Modal.Header>

                <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: bshzColors.ltPurple}}>

                    <br></br>
                    Enter the first date you <b>DON'T</b> want the review/analysis to include:
                    <br></br>
                    <SemanticDatepicker
                        onChange={this.onEndDateChange}
                        format="YYYY-MM-DD"
                        value={this.state.rawEndDateValue}
                        keepOpenOnClear={true}
                        filterDate={this.checkFilterEndDate}
                    /> &nbsp;
                    <Button onClick={this.toggleShowEndDateModal}
                                    content='SET' positive disabled={this.state.disableSetEndDateButton}/>
                    <Button onClick={clearEndDate}
                                    content='Clear/Cancel' negative/>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                </Modal.Content>

            </Modal>




        const clearDataModal = this.state.showClearDataModal ?
                    <Modal size='small' centered className={modalClassName}  open={true} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                        <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                            <span style={{color: this.bshzYellow}}> DELETE Coin Data? </span>
                        </Modal.Header>
                        <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>
                           We're about to DELETE EBX coin/deposit data (stored in this browser's DB)
                            <p></p>

                            <p></p>

                            <b>Are you SURE you want to do that?</b>
                        </Modal.Content>

                        <Modal.Actions className={modalBottomClassName} style={{backgroundColor: bshzColors.purple, borderRadius: '0px 0px 20px 20px'}}>
                            <div style={{textAlign: 'center'}}>
                                <Button onClick={this.actuallyDeleteData} positive>Yes, DELETE coin data</Button>
                                <br></br>
                                <Button onClick={this.hideClearData} negative>Back</Button>
                            </div>
                        </Modal.Actions>
                    </Modal>
                :
                    <></>

        const analysisModal = this.state.showAnalysisModal ?
                    <Modal size='small' centered className={modalClassName}  open={true} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                        <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                            <span style={{color: this.bshzYellow}}> Analyze EBX Deposits </span>
                        </Modal.Header>
                        <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>
                            Here we will allow analysis of EBX deposit data
                            <p></p>

                            <p></p>

                            <Table style={{border:'none', backgroundColor:"#00000000"}}>
                                <Table.Body>
                                    <Table.Row>
                                    <Table.Cell rowSpan={2} collapsing>
                                        <Button onClick={ () => this.analyzeDeposits([]) } content='Analyze' positive disabled={this.state.disableButtons}/>
                                    </Table.Cell>
                                    <Table.Cell style={{padding:'0px'}}>
                                        {limitStartDateCheckbox}
                                    </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                    <Table.Cell  style={{padding:'0px', border:'none'}}>
                                        {limitEndDateCheckbox}
                                    </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Modal.Content>

                        <Modal.Actions className={modalBottomClassName} style={{backgroundColor: bshzColors.purple, borderRadius: '0px 0px 20px 20px'}}>
                            <div style={{textAlign: 'center'}}>
                                <Button onClick={this.hideAnalysis} negative>Back</Button>
                            </div>
                        </Modal.Actions>
                </Modal>
                :
                    <></>

    // MODIFIED this to now solicitPassword( contents )
    //onClick={() => this.inspectContents(document.getElementById('contentPlaceHolder').innerHTML)} positive>
    return <>
            EBX deposits data options:
            <br></br>
            &nbsp; Review IDB-saved deposits data
            <br></br>
            &nbsp; <Button style={{backgroundColor:"blue", color:"white"}} onClick={this.showImporter}>Import more EBX deposits data</Button>
            <br></br>
            &nbsp; <Button positive >Enter EBX price data</Button>
            <br></br>
            &nbsp; <Button negative onClick={this.showAnalysis}>Analyze data</Button>
            <br></br>
            &nbsp; <Button negative onClick={this.showClearData}>Clear data</Button>

              {importerModal}
              {analysisModal}
              {clearDataModal}

              {maybeShowEndDateSetter}
              {maybeShowStartDateSetter}

              <Modal size='small' centered className={modalClassName}  open={this.state.showImportSwirly} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                    <span style={{color: this.bshzYellow}}> Importing Your Wallet File</span>
                </Modal.Header>
                <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp, borderRadius: '0px 0px 20px 20px'}}>

                    Please wait while we decrypt, and import your wallet file...
                    <br></br>

                    <Loader  inline style={{color: "black"}}>
                        Processing...
                    </Loader>
                    <br></br>
                </Modal.Content>
              </Modal>

              <Modal size='small' centered className={modalClassName}  open={this.state.showOkModal} style={{backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                <Modal.Header style={{textAlign: 'center', backgroundColor: this.bshzPurple, borderRadius: '20px'}}>
                    <span style={{color: this.bshzYellow}}> Wallet Import/Restore Complete </span>
                </Modal.Header>
                <Modal.Content className={modalContentClassName} scrolling style={{backgroundColor: this.bshzLtPurp}}>

                    We're done restoring your wallet keys and records.
                    <br></br>
                    We imported a total of <b style={{color:'blue', fontSize:'1.2rem'}}>{this.state.totalRecordsCount}</b> keys and records.

                    {skippedKeysMention}

                </Modal.Content>
                <Modal.Actions className={modalBottomClassName} style={{backgroundColor: this.bshzPurple, borderRadius: '0px 0px 20px 20px'}}>
                    <div style={{textAlign: 'center'}}>
                        <Button positive onClick={this.props.closeWalletImportModal} content='OK' autoFocus/>
                    </div>
                </Modal.Actions>
              </Modal>
          </>
  }
} // EbxDepositsImporter

export default EbxDepositsImporter;